// extracted by mini-css-extract-plugin
export default {"regionContainer":"Region_regionContainer__0GSqg","region":"Region_region__-+For","listContainer":"Region_listContainer__UsrpW","inputContainer":"Region_inputContainer__6A3qE"};